import script from "./DictionaryTemplatesPopulated.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryTemplatesPopulated.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryTemplatesPopulated.vue?vue&type=style&index=0&id=83c8bb3a&scoped=true&lang=scss"
import "./DictionaryTemplatesPopulated.vue?vue&type=style&index=1&id=83c8bb3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c8bb3a"]])

export default __exports__